import _Array$isArray from "@babel/runtime-corejs2/core-js/array/is-array";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { dataURItoBlob, shouldRender } from "@rjsf/core/lib/utils";
import { humanFileSize } from "customs/forms/utils";

function addNameToDataURL(dataURL, name) {
  return dataURL.replace(";base64", ";name=".concat(encodeURIComponent(name), ";base64"));
}

function FilesInfo(props, callback) {
    var filesInfo = props;

    if (filesInfo.length === 0) {
        return null;
    }

    return React.createElement("ul", {
        className: "file-info"
    }, filesInfo.map(function (fileInfo, key) {
        var name = fileInfo.name,
        size = fileInfo.size,
        type = fileInfo.type;
        return React.createElement("li", {
            key: key
        }, React.createElement(
            "strong", fileInfo.isError !== undefined && fileInfo.isError === true ? {style: {color: "red"}} : null, decodeURIComponent(name)
        ), " (", type, ", ", humanFileSize(size), ") ", React.createElement(
            "button", {
                style: {
                    backgroundColor: "red",
                    border: "aliceblue",
                    color: "white",
                    textAlign: "center",
                    textDecoration: "none",
                    display: "inline-block",
                    borderRadius: "3px"
                },
                type: "button",
                onClick: (e) => {
                    e.preventDefault();
                    callback(key);
                }
            }, "-"
        ));
    }));
}

function extractFileInfo(dataURLs) {
  return dataURLs.filter(function (dataURL) {
    return typeof dataURL !== "undefined";
  }).map(function (dataURL) {
    try {
      var _dataURItoBlob = dataURItoBlob(dataURL),
          blob = _dataURItoBlob.blob,
          name = _dataURItoBlob.name;

      return {
        name: name,
        size: blob.size,
        type: blob.type
      };
    } catch(e) {}
    return {name: "", size: 0, type: ''}; 
  }).filter(function (dataURL) {
    return dataURL.size > 0;
  });
}

var FileWidget =
/*#__PURE__*/
function (_Component) {
  _inherits(FileWidget, _Component);

  function FileWidget(props) {
    var _this;

    _classCallCheck(this, FileWidget);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FileWidget).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (event) {
      var _this$props = _this.props,
          multiple = _this$props.multiple,
          onChange = _this$props.onChange;
        const maxBytes = _this$props.options && _this$props.options.maxBytes ? _this$props.options.maxBytes : Infinity;
        const fileTypes = _this$props.options && _this$props.options.accept ? _this$props.options.accept.replaceAll(' ', '').split(',') : [];
        const maxBytesLabel = maxBytes === Infinity ? " unknown" : humanFileSize(maxBytes);

        _Promise.all([].map.call(event.target.files, (file) => {
        var name = file.name,
            size = file.size,
            type = file.type,
            dataURL = '',
            isError = false;
        return new _Promise(function (resolve, reject) {
            var reader = new window.FileReader();
            reader.onerror = reject;

            reader.onload = function (event) {
              dataURL = addNameToDataURL(event.target.result, name);
              if (file.size > maxBytes) {
                  name = name + " is too large, please limit to " + maxBytesLabel;
                  isError = true;
              } else if (fileTypes.length > 0 && !fileTypes.includes('.' + name.split('.').pop().toLowerCase())) {
                  name = name + " is not an accepted file type";
                  isError = true;
              }
              resolve({
                  dataURL: dataURL,
                  name: name,
                  size: size,
                  type: type,
                  isError: isError
              });
            };

            reader.readAsDataURL(file);
        })})).then(function (filesInfo) {
        var state = {
          values: filesInfo.map(function (fileInfo) {
            return fileInfo.dataURL;
          }),
          filesInfo: filesInfo
        };

        _this.setState(state, function () {
          if (multiple) {
            onChange(state.values);
          } else {
            onChange(state.values[0]);
          }
        });
      });
    });

    var value = props.value;
    var values = _Array$isArray(value) ? value : [value];
    _this.state = {
      values: values,
      filesInfo: extractFileInfo(values)
    };
    return _this;
  }

  _createClass(FileWidget, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      try {
        let updateState = false;
        let state = {};
        if (nextProps.value && ((this.state.values && this.state.values[0] === undefined) || this.state.filesInfo.length === 0)) {
          state = {
            values: [nextProps.value],
            filesInfo: extractFileInfo([nextProps.value])
          };
          updateState = true;
        } else if ((!nextProps.value || nextProps.value.length === 0) && ((this.state.values && this.state.values[0] !== undefined) || this.state.filesInfo.length > 0)) {
          state = {
            values: [undefined],
            filesInfo: []
          };
          updateState = true;
        }
        if (updateState) {
          this.setState(state, function () {
            if (this.props.multiple) {
              this.props.onChange(state.values);
            } else {
              this.props.onChange(state.values[0]);
            }
          });
        }
      } catch(e) {}
      return shouldRender(this, nextProps, nextState);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          multiple = _this$props2.multiple,
          id = _this$props2.id,
          readonly = _this$props2.readonly,
          disabled = _this$props2.disabled,
          autofocus = _this$props2.autofocus,
          onFocus = _this$props2.onFocus,
          onBlur = _this$props2.onBlur,
          options = _this$props2.options;
      var filesInfo = this.state.filesInfo;
      return React.createElement(
        "div",
        null,
        React.createElement(
          "p", null, React.createElement(
            "input",
            {
              ref: function ref(_ref) {
                return _this2.inputRef = _ref;
              },
              id: id,
              type: "file",
              disabled: readonly || disabled,
              onChange: this.onChange,
              onFocus: () => {onFocus(id, '');},
              onBlur: () => {
                if (multiple) {
                  onBlur(id, this.state.values);
                } else {
                  onBlur(id, this.state.values[0]);
                }
              },
              defaultValue: "",
              autoFocus: autofocus,
              multiple: multiple,
              accept: options.accept
            }
          )
        ),
        React.createElement(
          () => FilesInfo(filesInfo, (key) => {
            var state = {
              values: this.state.values.filter(function (data, k) {return k !== key;}),
              filesInfo: this.state.filesInfo.filter(function (data, k) {return k !== key;}),
            };
            this.setState(state, function () {
              _this2.inputRef.value = "";
              if (this.props.multiple) {
                this.props.onChange(state.values);
              } else {
                this.props.onChange(state.values[0]);
              }
            });
          }),
          {
            filesInfo: filesInfo
          }
        )
      );
    }
  }]);

  return FileWidget;
}(Component);

FileWidget.defaultProps = {
  autofocus: false
};

if (process.env.NODE_ENV !== "production") {
  FileWidget.propTypes = {
    multiple: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    autofocus: PropTypes.bool
  };
}

export default FileWidget;